import { DashboardTile, DashboardTileLayout, PackedTile, TileRow } from './types';

export const packTileRows = (tiles: DashboardTile[]): TileRow[] => {
  const visible = tiles.filter((tile) => tile.visible).sort((a, b) => a.priority - b.priority);
  const rows: TileRow[] = [];
  let index = 0;

  while (index < visible.length) {
    const tile = visible[index];
    const next = visible[index + 1];
    const canPair = tile.layout === DashboardTileLayout.Shared && next?.layout === DashboardTileLayout.Shared;

    if (canPair) {
      const pair: PackedTile[] = [
        { ...tile, isFull: false },
        { ...next, isFull: false },
      ];
      rows.push(pair);
      index += 2;
    } else {
      rows.push([{ ...tile, isFull: true }]);
      index += 1;
    }
  }

  return rows;
};
